module.exports = __webpack_public_path__ + "images/help/video-docs-62fe165fe0f1199a442be90e4e5370dc.png";